// tslint:disable:no-any
/**
 * Manage capabilities and handle its relevant data.
 * Use [[CapData]] for input.
 */
export class Director {
    /**
     * constructor
     * @param stage stage to use for rendering etc.
     */
    constructor(stage) {
        this._classCapMap = new Map();
        this._capMap = new Map();
        this._capNames = new Array();
        this._stage = stage;
    }
    /**
     * adds a new capability from a capfactory
     * @param factory
     */
    addCapability(cap) {
        if (cap.doClassToCapabilityMapping) {
            cap.doClassToCapabilityMapping(this._classCapMap);
        }
        return this._insertCap(cap);
    }
    /**
     * adds a new capability
     * @param name name of the capability
     * @param code function or string (js code) to execute
     */
    addCodeString(name, code) {
        const call = new Function('ObjectIn', 'SceneIn', code);
        const cap = {
            call,
            getName: () => {
                return name;
            },
        };
        return call != null;
    }
    /**
     * removes a capability
     * @param name name of the capability
     */
    removeCapability(name) {
        this._capMap.delete(name);
        const index = this._capNames.indexOf(name);
        if (index > -1) {
            this._capNames.splice(index, 1);
        }
    }
    /**
     * handles an object with a special capability
     * @param name name of the special capability
     * @param objectIn object to handle
     */
    handleWithCapability(name, objectIn) {
        const object = (objectIn.payload ? objectIn : this._convertToPayloaded(objectIn));
        const func = this._capMap.get(name)[object.funcName ? object.funcName : 'call']; // 'call' is the default func-name
        if (func) {
            return this._stage.applyCapability(func.bind(this._capMap.get(name)), object, !!object.scene ? object.scene : undefined);
        }
        else {
            // tslint:disable-next-line:no-console
            console.log('no mapping found for capability ' + name);
        }
        return false;
    }
    /**
     * handles an object of a special (crown) class
     * @param clazz the crown class (see crown manifest <data_format>)
     * @param object object to handle
     */
    handleForClass(clazz, object) {
        const className = this._classCapMap.has(clazz) ? clazz : getClassName(clazz, 0); // use full class or first part
        if (this._classCapMap.has(className)) {
            return this.handleWithCapability(this._classCapMap.get(className), object);
        }
        else {
            // tslint:disable-next-line:no-console
            console.log('no mapping for class ' + className + 'found!');
        }
        return false;
    }
    /**
     * handles object with a special capability or of a special class
     * @param capOrClass cap or class
     * @param object object to handle
     */
    handle(capOrClass, object) {
        return this.handleWithCapability(capOrClass, object) || this.handleForClass(capOrClass, object);
    }
    handleCapData(capdata) {
        this._handleObject(capdata);
    }
    _insertCap(cap) {
        if (this._capMap.has(cap.getName())) {
            // tslint:disable-next-line:no-console
            console.log('<Davinci> Capability "' + cap.getName() + '"already added (remove it before to add a new one)');
            return false;
        }
        this._capNames.unshift(cap.getName());
        this._capMap.set(cap.getName(), cap);
        return true;
    }
    _handleObject(object) {
        let result = false;
        if (object.capability !== undefined) {
            result = this.handleWithCapability(object.capability, object);
        }
        if (!result && object.class !== undefined) { // without payload (old way!)
            result = this.handleForClass(object.class, object);
        }
        if (!result && object.payload && object.payload.Type !== undefined) { // with payload
            result = this.handleForClass(object.payload.Type, object);
        }
        if (!result) {
            // tslint:disable-next-line:no-console
            console.log('no capability name found, try to find the right one...');
            for (const key of this._capNames) {
                result = this.handleWithCapability(key, object);
                if (result) {
                    return result;
                }
            }
            // tslint:disable-next-line:no-console
            console.warn('no capability found!');
        }
        return result;
    }
    _convertToPayloaded(obj) {
        return {
            payload: obj,
            materials: [obj.material],
            orientation: obj.orientation,
            scene: obj.scene,
            parent: obj.parent,
            name: obj.name,
            tag: obj.tag,
            shadow: obj.shadow,
            capability: obj.capability,
        };
    }
}
function getClassName(name, index) {
    const arr = name.split('.');
    return (arr.length > index) ? arr[index] : '';
}
//# sourceMappingURL=Director.js.map